// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6to5e","col":"styles_col__dgxSz","actions":"styles_actions__H2JT8","conflict":"styles_conflict__1Mx1x"};